document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.card-product-video').forEach(function (video) {
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'auto';

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    function playVideo() {
      var promise = video.play();

      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {});
      }
    }

    playVideo();

    video.addEventListener('loadeddata', playVideo);
    video.addEventListener('canplay', playVideo);

    video.addEventListener('click', function (event) {
      if (video.paused) {
        event.preventDefault();
        event.stopPropagation();
        playVideo();
      }
    });
  });
});
